module.exports = require('./lib/main')



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/index.js
// module id = 72
// module chunks = 3